import { RootState } from '@shared/model';

export const selectIsGenerationReportShown = (state: RootState) => state.reportsSection.generationReport.isReportShown;
export const selectIsSendingReportShown = (state: RootState) => state.reportsSection.sendingReport.isReportShown;
export const selectSendingStartedAt = (state: RootState) => state.reportsSection.sendingReport.startedAt;
export const selectSendingFinishedAt = (state: RootState) => state.reportsSection.sendingReport.finishedAt;
export const selectIsSendingTimedOut = (state: RootState) => state.reportsSection.sendingReport.isTimedOut;
